/**
 * The name a person should be shown under.
 *
 * Logins here are generated random on purpose — `user-27b1a9` says nothing
 * about who holds it, which is the right shape for something you type to sign
 * in and the wrong one for what a friend reads when their phone rings. The
 * display name is chosen by its owner; the login is the fallback, never the
 * preference.
 *
 * The server sends both, and computes the same fallback in SQL
 * (displayNameSql), so a person cannot appear by name in one list and as a
 * serial number in another.
 */
export function displayName(user) {
  if (!user) return '';
  const chosen = typeof user.display_name === 'string' ? user.display_name.trim() : '';
  return chosen || user.username || '';
}

/** Initials for an avatar, from whatever name we are showing. */
export function nameInitials(user) {
  const n = typeof user === 'string' ? user : displayName(user);
  const parts = n.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
